import { lazy, Suspense, useEffect, useState } from 'react'
import { useUser } from '@runtime/core/user/userContext'
import PlayErrorBoundary from '@/core/resilience/PlayErrorBoundary'
import PlayRoutePending from '@/components/layout/playShell/PlayRoutePending'

const PosterModal = lazy(() => import('@runtime/features/poster/PosterModal'))
const ProfileModal = lazy(() => import('@runtime/features/profile/ProfileModal'))

function useRequested(open: boolean) {
  const [requested, setRequested] = useState(open)
  useEffect(() => {
    if (open) setRequested(true)
  }, [open])
  return open || requested
}

// Keep requested panels mounted so their existing close/reset lifecycle stays in control.
export default function PlayAccountOverlays({
  posterOpen,
  loginOpen,
  onClosePoster,
}: {
  posterOpen: boolean
  loginOpen: boolean
  onClosePoster: () => void
}) {
  const { setLoginOpen } = useUser()
  const posterRequested = useRequested(posterOpen)
  const profileRequested = useRequested(loginOpen)
  return (
    <>
      <PlayErrorBoundary panel={{ open: posterOpen, close: onClosePoster }}>
        <Suspense fallback={<PlayRoutePending />}>
          {posterRequested && <PosterModal open={posterOpen} onClose={onClosePoster} />}
        </Suspense>
      </PlayErrorBoundary>
      <PlayErrorBoundary panel={{ open: loginOpen, close: () => setLoginOpen(false) }}>
        <Suspense fallback={<PlayRoutePending />}>
          {profileRequested && <ProfileModal open={loginOpen} />}
        </Suspense>
      </PlayErrorBoundary>
    </>
  )
}
